import { render, staticRenderFns } from "./ClinicVideosStatus.vue?vue&type=template&id=5413808a&"
import script from "./ClinicVideosStatus.vue?vue&type=script&lang=js&"
export * from "./ClinicVideosStatus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports